<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <radial-bar-card-line
        v-if="type === 'radialBar' && analyticsData"
        :leftDataTitle="chartData.leftDataTitle"
        :leftDataTitlei18n="chartData.leftDataTitlei18n"
        :rightDataTitle="chartData.rightDataTitle"
        :rightDataTitlei18n="chartData.rightDataTitlei18n"
        :leftDataValue="analyticsData.leftDataValue"
        :rightDataValue="analyticsData.rightDataValue"
        :dataFilter="chartData.dataFilter"
        @onDrillTo="drillTo"
        @onZoomIn="zoomIn"
        :enableZoomIn="enableZoomIn"
        :title="title"
        :i18n="i18n"
        :linkTo="linkTo"
        :chartData="analyticsData.series"/>
    <statistics-card-line
        v-if="type === 'statistics' && analyticsData"
        :icon="chartData.icon"
        :statistic="analyticsData.statistic"
        :title="title"
        :i18n="i18n"
        :linkTo="linkTo"
        :chartData="analyticsData.series"
        :dataFilter="chartData.dataFilter"
        @onDrillTo="drillTo"
        @onZoomIn="zoomIn"
        :enableZoomIn="enableZoomIn"
        type="area" />
    <comparaison-line-card-line
      v-if="type === 'comparaisonLine' && analyticsData"
      :leftDataTitle="chartData.leftDataTitle"
      :leftDataTitlei18n="chartData.leftDataTitlei18n"
      :rightDataTitle="chartData.rightDataTitle"
      :rightDataTitlei18n="chartData.rightDataTitlei18n"
      :leftDataValue="analyticsData.leftDataValue"
      :rightDataValue="analyticsData.rightDataValue"
      :dataFilter="chartData.dataFilter"
      :linkTo="linkTo"
      @onDrillTo="drillTo"
      @onZoomIn="zoomIn"
      :enableZoomIn="enableZoomIn"
      :title="title"
      :i18n="i18n"
      :categories="chartData.categories"
      :chartData="analyticsData.series"/>
    <column-chart-card
       v-if="type === 'basicColumn' && analyticsData"
      :linkTo="linkTo"
      @onDrillTo="drillTo"
      @onZoomIn="zoomIn"
      :enableZoomIn="enableZoomIn"
      :title="title"
      :i18n="i18n"
      :categories="chartData.categories"
      :yAxisTitle="chartData.yAxisTitle"
      :yAxisTitlei18n="chartData.yAxisTitlei18n"
      :chartData="analyticsData.series"/>
    <donut-chart-card
       v-if="type === 'basicDonut' && analyticsData"
      :linkTo="linkTo"
      @onDrillTo="drillTo"
      @onZoomIn="zoomIn"
      @onChildClick="childClick"
      :enableDrill="chartData ? chartData.enableDrill : false"
      :enableZoomIn="enableZoomIn"
      :title="title"
      :i18n="i18n"
      :dataFilter="chartData.dataFilter"
      :labels="analyticsData.labels"
      :size="chartData ? chartData.size : 0"
      :comparisonData="analyticsData.comparisonData"
      :chartData="analyticsData.series" />
     <comparaison-bar-card
      v-if="type === 'comparaisonBar' && analyticsData"
      :leftDataTitle="chartData.leftDataTitle"
      :leftDataTitlei18n="chartData.leftDataTitlei18n"
      :rightDataTitle="chartData.rightDataTitle"
      :rightDataTitlei18n="chartData.rightDataTitlei18n"
      :leftDataValue="analyticsData.leftDataValue"
      :rightDataValue="analyticsData.rightDataValue"
      :dataFilter="chartData.dataFilter"
      :linkTo="linkTo"
      @onDrillTo="drillTo"
      @onZoomIn="zoomIn"
      :enableZoomIn="enableZoomIn"
      :title="title"
      :i18n="i18n"
      :categories="chartData.categories"
      :chartData="analyticsData.series"/>
    <table-card
      v-if="type === 'table' && analyticsData"
      :title="title"
      :i18n="i18n"
      :linkTo="linkTo"
      @onDrillTo="drillTo"
      @onZoomIn="zoomIn"
      :enableZoomIn="enableZoomIn"
      :tableData="analyticsData"
      :columnDefs="chartData.columnDefs" />

  </div>
</template>

<script>
import StatisticsCardLine from './StatisticsCardLine.vue'
import RadialBarCardLine from './RadialBarCardLine.vue'
import ComparaisonLineCardLine from './ComparaisonLineCardLine.vue'
import ComparaisonBarCard from './ComparaisonBarCard.vue'
import ColumnChartCard  from './ColumnChartCard.vue'
import DonutChartCard from './DonutChartCard.vue'
import TableCard from './TableCard.vue'

export default {
  props: {
    type: {
      type: String
    },
    title: {
      type: String
    },
    i18n: {
      type: String
    },
    analyticsData: {},
    chartData: {},
    zoomInData: null,
    linkTo: {
      type: String
    },
    enableDrill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enableZoomIn () { 
      return this.zoomInData !== null && typeof this.zoomInData !== 'undefined'
    }
  },
  components: {
    StatisticsCardLine,
    RadialBarCardLine,
    ComparaisonLineCardLine,
    ColumnChartCard,
    DonutChartCard,
    ComparaisonBarCard,
    TableCard
  },
  created () {

  },
  methods : {
    zoomIn() {
      this.$emit("onZoomIn", this.zoomInData);
    },
    drillTo(linkTo) {
      this.$emit("onDrillTo", linkTo);
    },
    childClick(parent) {
      this.$emit("onChildClick", parent);
    }
  }
}
</script>
